import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { PieceJointe } from './piece-jointe.model';
import { PieceJointeService } from './piece-jointe.service';
@Injectable()
export class PieceJointePopupService {
    private isOpen = false;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private pieceJointeService: PieceJointeService
    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.pieceJointeService.find(id).subscribe(pieceJointe => {
                pieceJointe.dateCreation = this.datePipe.transform(pieceJointe.dateCreation, 'yyyy-MM-ddThh:mm');
                pieceJointe.dateModification = this.datePipe.transform(pieceJointe.dateModification, 'yyyy-MM-ddThh:mm');
                pieceJointe.dateConformite = this.datePipe.transform(pieceJointe.dateConformite, 'yyyy-MM-ddThh:mm');
                this.pieceJointeModalRef(component, pieceJointe);
            });
        } else {
            return this.pieceJointeModalRef(component, new PieceJointe());
        }
    }

    pieceJointeModalRef(component: Component, pieceJointe: PieceJointe): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.pieceJointe = pieceJointe;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe-popup.service.ts